import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const PackageIcon: FC<SvgProps> = ({ fill = ColorEnum.BRICK_600, ...props }) => {
    return (
        <Svg width={16} height={16} {...props}>
            <Path
                fill={fill}
                d="m6.892 6.643.648-.325A.945.945 0 0 1 8 6.203c.166 0 .319.038.46.115l.648.325V3.648H6.892v2.995ZM5.36 11.312a.65.65 0 0 1-.477-.194.644.644 0 0 1-.195-.475c0-.187.065-.347.195-.478a.645.645 0 0 1 .477-.197h1.968a.65.65 0 0 1 .478.194c.13.128.194.287.194.474a.656.656 0 0 1-.194.479.645.645 0 0 1-.478.197H5.36Zm-1.712 2.424c-.383 0-.71-.135-.98-.405a1.333 1.333 0 0 1-.403-.979V3.648c0-.383.134-.71.404-.98.27-.269.596-.404.979-.404h8.704c.383 0 .71.135.98.405.269.27.404.596.404.979v8.704c0 .383-.135.71-.405.98-.27.269-.596.403-.979.403H3.648Zm0-1.384h8.704V3.648h-1.9V7.71c0 .26-.108.456-.325.588a.655.655 0 0 1-.674.025L8 7.6l-1.453.723a.655.655 0 0 1-.674-.025.646.646 0 0 1-.325-.588V3.648h-1.9v8.704Z"
            />
        </Svg>
    )
}

export default PackageIcon
